import service from "./service";
import { i18n } from "../../i18n";
import store from "@/store/store";

const state = {
  table: "pokojni",
  query: "",
  expanded: true,
  columns: [
    {
      label: i18n.t("deceased.person"),
      field: "pokojni"
    },
    {
      label: i18n.t("deceased.show"),
      field: "actions"
    }
  ],
  rows: []
};

const getters = {};

const mutations = {
  setQuery(state, query) {
    state.query = query;
  },
  setRows(state, rows) {
    state.rows = rows;
  },
  reset(state) {
    state.rows = [];
  },
  toggle(state, expanded) {
    state.expanded = expanded;
  }
};

const actions = {
  async get(context, search) {
    context.commit("setQuery", search);
    const data = { search };

    const table = context.state.table;
console.log(store.state.view);
    const portal = store.state.view.portal;
    if (portal) {
      data.portal = portal;
    }

    return service
      .get(table, data)
      .then(data => {
        context.commit("setRows", data.data);
      })
      .catch(() => {
        context.commit("reset");
      });
  },
  reset(context) {
    context.commit("reset");
  },

  toggle(context, expand) {
    context.commit("toggle", expand);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
